import { render } from "./Dashboard.vue?vue&type=template&id=97f350f6&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=97f350f6&scoped=true&lang=css"

import exportComponent from "C:\\PRO\\TimeSheet\\vue-cal-dev-ts-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97f350f6"]])

export default __exports__